/**
 * Tool approval helper functions
 */

import type { UIMessage } from 'ai';
import type { ToolPartWithState } from './toolInvocations';

/**
 * Check if the last assistant message has an approved tool call ready to send.
 *
 * This helper simplifies the sendAutomaticallyWhen logic by extracting the
 * condition check into a reusable function. It checks for:
 * - Last message is from assistant
 * - Has a part with state === 'approval-responded'
 * - Has approval.approved === true
 *
 * This is used with sendAutomaticallyWhen to auto-send after user approves a tool.
 */
export function hasApprovedToolCallReadyToSend(messages: UIMessage[]): boolean {
  const lastMessage = messages.at(-1);
  const result = (
    lastMessage?.parts?.some(
      (part: unknown) =>
        typeof part === 'object' &&
        part !== null &&
        'state' in part &&
        (part as ToolPartWithState).state === 'approval-responded' &&
        'approval' in part &&
        (part as ToolPartWithState).approval?.approved === true
    ) ?? false
  );
  return result;
}
